import keyMirror from 'keymirror'
import i18n from '@/utils/i18n'

export const WP_ACTION_TYPE = keyMirror({
  /**
   * Main Contractor Work Permit 1st Review
   * @const
   */
  PPReview1: null,
  /**
   *Main Contractor Work Permit 2nd Review
   * @const
   */
  PPReview2: null,
  /**
   * Main Contractor Work Permit Approve
   * @const
   */
  PPApprove: null,
  /**
   * Sub Contractor Work Permit Review
   * @const
   */
  WPReview: null,
  WPReview2: null,
  WPReview3: null,
  /**
   * Sub Contractor Work Permit Approve
   * @const
   */
  WPApprove: null,
  /**
   * Hoisting in Non-Office Hours Review
   * @const
   */
  HPReview: null,
  /**
   * Hoisting in Non-Office Hours Approve
   * @const
   */
  HPApprove: null,
})

export function wpNextReviewerLabel () {
  return {
    [WP_ACTION_TYPE.PPReview1]: i18n.t('workPermit.nextReviewerModalTitle.PPReview1'),
    [WP_ACTION_TYPE.PPReview2]: i18n.t('workPermit.nextReviewerModalTitle.PPReview2'),
    [WP_ACTION_TYPE.PPApprove]: i18n.t('workPermit.nextReviewerModalTitle.PPApprove'),
    [WP_ACTION_TYPE.WPReview]: i18n.t('workPermit.nextReviewerModalTitle.WPReview'),
    [WP_ACTION_TYPE.WPReview2]: i18n.t('workPermit.nextReviewerModalTitle.WPReview2'),
    [WP_ACTION_TYPE.WPReview3]: i18n.t('workPermit.nextReviewerModalTitle.WPReview3'),
    [WP_ACTION_TYPE.WPApprove]: i18n.t('workPermit.nextReviewerModalTitle.WPApprove'),
    [WP_ACTION_TYPE.HPReview]: i18n.t('workPermit.nextReviewerModalTitle.HPReview'),
    [WP_ACTION_TYPE.HPApprove]: i18n.t('workPermit.nextReviewerModalTitle.HPApprove'),
  }
}

export const WP_ACTION_PERMS_MAP = {
  [WP_ACTION_TYPE.PPReview1]: 'TMWORKPERMIT_REVIEW_1ST',
  [WP_ACTION_TYPE.PPReview2]: 'TMWORKPERMIT_REVIEW_2ND',
  [WP_ACTION_TYPE.PPApprove]: 'TMWORKPERMIT_APPR',
  [WP_ACTION_TYPE.WPReview]: 'WORKPERMIT_REVIEW',
  [WP_ACTION_TYPE.WPReview2]: 'WORKPERMIT_REVIEW_2ND',
  [WP_ACTION_TYPE.WPReview3]: 'WORKPERMIT_REVIEW_3RD',
  [WP_ACTION_TYPE.WPApprove]: 'WORKPERMIT_APPR',
  [WP_ACTION_TYPE.HPReview]: 'HP_NOOFFICEHOUR_REVIEW',
  [WP_ACTION_TYPE.HPApprove]: 'HP_NOOFFICEHOUR_APPR',
}

export const WORK_PERMIT_TYPES = keyMirror({
  PROJECT: null,
  WORK: null,
  HOISTING: null,
})

export const ALL_FLOORS = 'All Floors'
export const WORK_PERMIT_EXTENDED = 'Extended'
export const WORK_PERMIT_STATUS = keyMirror({
  DRAFT: null,
  WAPPR: null,
  REVIEWED: null,
  REVIEWED2: null,
  ACKNOWLEDGED: null,
  REJECTED: null,
  APPR: null,
  ENDED: null,
  SUSPENDED: null,
  COMPLETED: null,
  INPROGRESS: null,
  EXPIRED: null,
  CANCELLED: null,
})

export const WP_SA = 'Standalone'

export const WP_PROJECT_TYPES = [WP_SA, 'Contract', 'PO', 'Fitout', 'Reinstatement']
export const WP_PROJECT_TYPE_MAP = {
  Fitout: 'Fitout',
  Reinstatement: 'Reinstatement',
  PO: 'PO',
  CONTRACT: 'Contract',
}

export const CreateWorkPermitTabs = {
  generalInfo: 0,
  workerInfo: 1,
  hoistingHotWork: 2,
}

export function getWorkTypeMap () {
  return {
    SURVEY: i18n.t('workPermit.workTypes.survey'),
    DEFECT: i18n.t('workPermit.workTypes.defect'),
    TELECOM: i18n.t('workPermit.workTypes.telecom'),
    TC: i18n.t('workPermit.workTypes.tnc'),
    FIT_OUT: i18n.t('workPermit.workTypes.fitout'),
    INSTALLATION: i18n.t('workPermit.workTypes.installation'),
    MAINTENANCE: i18n.t('workPermit.workTypes.maintenance'),
    REINSTATEMENT: i18n.t('workPermit.workTypes.reinstatement'),
    REPAIR: i18n.t('workPermit.workTypes.repair'),
    EVENT: i18n.t('workPermit.workTypes.event'),
    BAISUN: i18n.t('workPermit.workTypes.baisun'),
    SA_SURVEY: i18n.t('workPermit.workTypes.saSurvey'),
    OTHERS: i18n.t('workPermit.workTypes.other'),
  }
}

export function getWorkTypeListMap () {
  const WORK_TYPE = getWorkTypeMap()
  return [
    WORK_TYPE.SURVEY,
    WORK_TYPE.DEFECT,
    WORK_TYPE.TC,
    WORK_TYPE.FIT_OUT,
    WORK_TYPE.INSTALLATION,
    WORK_TYPE.MAINTENANCE,
    WORK_TYPE.REINSTATEMENT,
  ]
}

export function getSAWorkTypeListMap () {
  const WORK_TYPE = getWorkTypeMap()
  return [
    WORK_TYPE.REPAIR,
    WORK_TYPE.SA_SURVEY,
    WORK_TYPE.TELECOM,
    WORK_TYPE.EVENT,
    WORK_TYPE.BAISUN,
  ]
}

/**
 * NoticeOnWorkerBadgesEN, NoticeOnWorkerBadgesCN, NoticeHotWorkContent Moved To i18n
 * {
 *  headline: '', 14px bold
 *  subtitle: '', 14px normal
 *  paragraphs: [ 14px normal
 *    string1,
 *    {
 *      headline,
 *      subtitle,
 *      paragraphs: ...
 *    },
 *    ...
 *  ]
 * }
*/

export const DEFAULT_MAX_WAPPR_HOISTING_NUM = 7

export const WP_ACTION_TYPE_BY_NEXT_STATUS_MAPPING = {
  [WORK_PERMIT_STATUS.WAPPR]: WP_ACTION_TYPE.WPReview,
  [WORK_PERMIT_STATUS.ACKNOWLEDGED]: WP_ACTION_TYPE.WPReview2,
  [WORK_PERMIT_STATUS.REVIEWED]: WP_ACTION_TYPE.WPReview3,
  [WORK_PERMIT_STATUS.REVIEWED2]: WP_ACTION_TYPE.WPApprove,
}

export const WP_ACTION_ALLOWED_STATUS = [WORK_PERMIT_STATUS.ACKNOWLEDGED, WORK_PERMIT_STATUS.REVIEWED, WORK_PERMIT_STATUS.REVIEWED2]

export const BLOCK_STATUS_FOR_NON_ENGINEER = WP_ACTION_ALLOWED_STATUS
